import request from '../../request'
import {surveyQuestion} from '../../endpoints'

export default class surveyQuestionApi {
  static async addSurveyQuestion(data) {
    return request({
      url: surveyQuestion.addSurveyQuestion(),
      method: 'POST',
      data: data,
    })
  }
  static async addSurveyQuestionRemoveTempId(
    surveyId,
    replaceQdId,
    newQid,
    order
  ) {
    return request({
      url: surveyQuestion.addSurveyQuestionRemoveTempId(
        surveyId,
        replaceQdId,
        newQid,
        order
      ),
      method: 'GET',
    })
  }
  // orderIsItemPosition: `order` is the question's place among all the survey's items (content
  // screens and skip-logic sections included), not its question number.
  static async post(data, {orderIsItemPosition = false} = {}) {
    return request({
      url: surveyQuestion.post({orderIsItemPosition}),
      method: 'POST',
      data: data,
    })
  }

  static async addSurveyQuestionList(data) {
    return request({
      url: surveyQuestion.addSurveyQuestionList(),
      method: 'POST',
      data: data,
    })
  }
  static async put(data) {
    return request({
      url: surveyQuestion.put(),
      method: 'PUT',
      data: data,
    })
  }

  static async getByToken(token) {
    return request({
      url: surveyQuestion.getByToken(),
      method: 'POST',
      data: token,
    })
  }

  static async delete(surveyId, questionId) {
    return request({
      url: surveyQuestion.delete(questionId, surveyId),
      method: 'DELETE',
    })
  }

  static async reorderSurveyQuestions(f, t, fIdx, tIdx, sId) {
    return request({
      url: surveyQuestion.reorderSurveyQuestions(f, t, fIdx, tIdx, sId),
      method: 'GET',
    })
  }
  //   static async getAll(cId, cType, limit) {
  //     return request({
  //       url: survey.getAll(cId, cType, limit),
  //       method: 'GET',
  //     })
  //   }
}
